import dayjs from 'dayjs';

export class Dates {
    public ToUtcDate(dateStr: string) {
        const date = dateStr && dateStr.length >= 19 ? new Date(dateStr.substring(0, 19) + 'Z') : new Date(dateStr);
        return new Date(
            date.getUTCFullYear(),
            date.getUTCMonth(),
            date.getUTCDate(),
            date.getUTCHours(),
            date.getUTCMinutes(),
            date.getUTCSeconds()
        );
    }
    public addMinutes(value: Date, minutes: number): Date {
        const date = dayjs(value);
        return date.add(minutes, 'minutes').toDate();
    }
}

export function MinDate(date1: dayjs.Dayjs, date2: dayjs.Dayjs) {
    return date1.isBefore(date2) ? date1 : date2;
}

export function MaxDate(date1: dayjs.Dayjs, date2: dayjs.Dayjs) {
    return date1.isAfter(date2) ? date1 : date2;
}

export default new Dates();
